import { Box, useTheme } from "@mui/material";
import { INavbarIconVariant, NavbarIcon } from "../../atoms/navbar/Icon";
import { Question } from "../../models/types";
import { TableTextWithEllipsis } from "../TableTextWithEllipsis";
import { QuestionIconIndex } from "./QuestionIconIndex";
import { memo } from "react";

type QuestionnaireBuilderQuestionTitleProps = {
  question: Question;
  selected: boolean;
  onClick: (question: Question) => void;
  index: number;
  questionGroup?: boolean;
};

export const QuestionnaireBuilderQuestionTitle = memo(
  (props: QuestionnaireBuilderQuestionTitleProps) => {
    const { question, selected, onClick, index, questionGroup = false } = props;
    const theme = useTheme();

    return (
      <Box
        width="100%"
        display="flex"
        padding="8px"
        borderRadius="3px"
        bgcolor={
          selected
            ? theme.palette.custom.secondaryBackground
            : questionGroup
            ? theme.palette.custom.white
            : "none"
        }
        border={`1px solid ${
          selected ? theme.palette.custom.hyperlink : theme.palette.custom.secondaryBorder
        }`}
        onClick={(e) => {
          e.stopPropagation();
          onClick(question);
        }}
        sx={{
          ":hover": {
            cursor: "pointer",
          },
        }}
        alignItems="center"
        gap="8px"
      >
        <QuestionIconIndex
          icon={question.icon as INavbarIconVariant}
          bgcolor={
            selected ? theme.palette.custom.blueTypography : theme.palette.custom.primaryBorder
          }
          color={
            selected ? theme.palette.custom.whiteTypography : theme.palette.custom.primaryTypography
          }
          index={index.toString()}
          fill={
            question.icon === "reports-list" ||
            question.icon === "single-choice" ||
            question.icon === "yes-no" ||
            question.icon === "dropdown"
              ? selected
                ? theme.palette.custom.white
                : theme.palette.custom.primaryTypography
              : undefined
          }
        />
        <TableTextWithEllipsis
          value={question.title}
          variant="h4"
          color={selected ? theme.palette.custom.hyperlink : theme.palette.custom.primaryTypography}
          expanded
        />
        {questionGroup && (
          <Box display="flex" justifyContent="flex-end">
            <NavbarIcon
              variant="right-arrow"
              strokeWidth="2"
              sx={{
                width: "20px",
                height: "20px",
                minHeight: "20px",
                minWidth: "20px",
              }}
            />
          </Box>
        )}
      </Box>
    );
  },
  (prevProps, nextProps) => {
    return (
      prevProps.question.ref === nextProps.question.ref &&
      prevProps.question.title === nextProps.question.title &&
      prevProps.selected === nextProps.selected &&
      prevProps.index === nextProps.index &&
      prevProps.onClick === nextProps.onClick
    );
  }
);
